import React, { useEffect, useMemo } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { getMaintenanceStart } from "../../redux-saga/redux/settings";
import BrandLogo from "../SportsBookNode/BrandLogo";
import { MAINTENANCE_IGNORE_IDS } from "../../utils/constants";
import useStyles from "./Maintenance.style.js";

const Maintenance = ({ children }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const totalShutdown = useSelector((state) => state.settings.totalShutdown);
  //   const loading = useSelector((state) => state.settings.loading);

  const userId = useSelector((state) => state?.authentication?.userId);
  const isLoggedIn = useSelector((state) => state?.authentication?.isLoggedIn);
  const ignoreMaintenance = useMemo(
    () => MAINTENANCE_IGNORE_IDS?.includes(`${userId}`),
    [userId]
  );
  useEffect(() => {
    if (isLoggedIn) dispatch(getMaintenanceStart());
  }, [dispatch, isLoggedIn]);

  //   if (loading) {
  //     return <LinearProgress className="maintenance-site-loader" />;
  //   }
  if (totalShutdown && !ignoreMaintenance) {
    if (totalShutdown) {
      return (
        <Grid className={classes.siteMaintenanceWrapper}>
          <div className={classes.maintenanceImageWrap}>
            <BrandLogo height={200} width={200} />
          </div>
          <Typography variant="h5" className={classes.maintenanceText}>
            {t("HOME.MAINTENANCE")}
          </Typography>
          <Typography variant="h6" className={classes.maintenanceText}>
            {t("HOME.BACK_SHORTLY")}
          </Typography>
          <div className={classes.maintenanceImageWrap}>
            <img
              width="100px"
              height="100px"
              alt=""
              src="/images/maintenance.svg"
            />
          </div>
        </Grid>
      );
    }
    //   if (loading !== null) {
    return children;
    //   }
  }
  return children;
};

export default Maintenance;
